export default {
  cn: [
    {
      version: '2.3.0',
      time: '2022.05.18',
      changes: [
        '更新行政区划数据至 <kbd>2022年05月18日</kbd>',
        '<kbd>Text</kbd> 模式增加文本分割符 <kbd class="kbd-code">separator</kbd> prop，默认设置为空格',
        '<kbd>CityPicker</kbd> 模式增加 <kbd class="kbd-code">overflow</kbd> prop 用于设置选中多个城市的情况下，仅显示一定数量的城市，其他城市进行折叠，仅显示数量；默认值为 <kbd class="kbd-code">false</kbd>',
        '统一修改 <kbd class="kbd-code">i18n</kbd> prop 名为 <kbd class="kbd-code">language</kbd>',
        '统一修改 <kbd class="kbd-code">values</kbd> 数据响应事件为 <kbd class="kbd-code">change</kbd>',
        '重构内部实现',
        '拆分五个模块为独立的模块进行应用',
        '增加省、市、区/县三级数据模型输出',
        '分组选择器（Group）的标题栏中移除 <kbd class="kbd-code">完成</kbd> 图标按钮',
        '增加 <kbd>RegionGroupCore</kbd> 与 <kbd>RegionColumnsCore</kbd> 模块输出，可用于直接嵌入页面使用，而非默认的选择器形态，更可以进一步进行二次封装使用',
        '更新部分风格样式'
      ]
    }, {
      version: '2.2.2',
      time: '2019.10.13',
      changes: [
        '使用 <b>render</b> 函数的方式完全重构插件',
        '重构样式设计，使得交互界面更加简洁、清晰',
        '移除 <code>ui</code>、<code>text</code>、<code>column</code> 和 <code>city-picker</code> prop 入参，改为使用 <code>type</code> prop 进行设置，默认值为 "select"',
        '移除 <code>selected</code> prop',
        '增加 <code>v-model/value</code> 支持',
        '增加自定义选择器呼出对象的作用域插槽（scoped slot）支持，输出 "region" 和 "show" 数据',
        '增加单元测试及代码测试覆盖率检测',
        '修改 css 预编译程序从 <b>SCSS</b> 至 <b>Stylus</b>',
        '使用 <b>Javascript Standard</b> 语法标准对项目进行格式化',
        '升级 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> 升级至 v2.1.1 版本'
      ]
    }, {
      version: '2.1.3',
      time: '2018.11.26',
      changes: [
        '修复 slot 内容子孙组件继承问题',
        '增加城市选择器模式，使用省份作为标题排头，城市作为列表展示，通过 <code>city-picker</code> 进行使用',
        '修复“省辖县/省辖县级市”展示不正确的问题',
        '修复初始化并选中项目后，修改省级，“区/县”、“乡/镇/街道”级别没有被清空的问题',
        '修复在选择项目后，点击 X 清空数据后，再次点击按钮，不会呼出菜单的问题'
      ]
    }, {
      version: '2.0.0',
      time: '2018.11.17',
      changes: [
        '重构插件',
        '修复地级市（“直筒子市”）的“区/县”级别无数据的问题',
        '为直辖市、地级市（“直筒子市”）增加相应的虚拟级别数据',
        '增加 <code>disabled</code> 参数，允许禁用表单下拉选择元素模式下禁用选择项目',
        '增加行政区划选择器多列竖排模式，通过 <code>column</code> 进行使用',
        '增加选择器模式在选中项目后，自动出现 <code>x</code> 图标，允许清除已选择内容'
      ]
    }, {
      version: '1.8.1',
      time: '2018.10.06',
      changes: [
        '增加 UI 选择器模式下呼出选择器的默认按钮',
        '修复省/直辖市切换时，城市显示不正确',
        '修改 UI 选择器模式在选择完最后一个级别内容时，自动关闭选择器界面',
        '下拉菜单容器使用插件 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>',
        '调整图标字体名称，避免与用户环境中的 iconfont 内容冲突',
        '完善 i18n 内容'
      ]
    }, {
      version: '1.7',
      time: '2018.06.21',
      changes: [
        '修复直辖市和常规省份切换时，区/县 以及 乡/镇/街道 数据未清空的问题'
      ]
    }, {
      version: '1.6',
      time: '2018.06.19',
      changes: [
        '修复常规表单模式下修改上级区域，原下级区域还保留的问题',
        '增加纯文本信息输出模式，设置 text 参数为 true',
        '修复部分样式排版问题',
        '修复部分行政区/县无下级数据时出错的问题'
      ]
    }, {
      version: '1.5',
      time: '2018.06.09',
      changes: [
        '修复选择器模式下打开选择器，界面会滚动顶部的问题'
      ]
    }, {
      version: '1.3-1.4',
      time: '2018.05-2018.06',
      changes: [
        '增加下拉选择器模式'
      ]
    }, {
      version: '1.0-1.2',
      time: '2018.04-2018.05',
      changes: [
        '开发并发布基于 <strong>Vue2</strong> 的 <code>v-region</code> 插件'
      ]
    }
  ],

  en: [
    {
      version: '2.3.0',
      time: '2022.05.18',
      changes: [
        'Updated region date to <kbd>2022-05-18</kbd>',
        'Added <kbd class="kbd-code">separator</kbd> prop in <kbd>Text</kbd> mode, empty string by default, used to separate each levels',
        'Added <kbd class="kbd-code">overflow</kbd> prop in <kbd>CityPicker</kbd> mode, <kbd class="kbd-code">false</kbd> by default, used to set when multiple cities are selected, only a certain number of cities are displayed, other cities are folded, and only the number is displayed',
        'Uniformly modify language prop name <kbd class="kbd-code">i18n</kbd> to <kbd class="kbd-code">language</kbd>',
        'Uniformly modify data response event name <kbd class="kbd-code">values</kbd> to <kbd class="kbd-code">change</kbd>',
        'Refactor the internal implementation',
        'Splitting five modules into separate modules for application',
        'Exported province, city, area data model',
        'Removed <kbd class="kbd-code">Finish</kbd> icon button in Group mode header',
        'Added new module <kbd>RegionGroupCore</kbd> and <kbd>RegionColumnsCore</kbd> export',
        'Updated some styles'
      ]
    }, {
      version: '2.2.2',
      time: '2019.10.13',
      changes: [
        'Use <b>render functions</b> to completely refactored plugin',
        'Refactoring style design makes the interface more concise and clear',
        'Removed <code>ui</code>, <code>text</code>, <code>column</code> and <code>city-picker</code> props, change to use <code>type</code> prop to specify plugin type, "select" by default',
        'Removed <code>selected</code> prop',
        'Added <code>v-model/value</code> support',
        'Added scoped slot support for custom region toggle, output "region" and "show" arguments',
        'Added unit test and code coverage detection',
        'Change css pre-processor program from <b>SCSS</b> to <b>Stylus</b>',
        'Use <b>Javascript Standard</b> code style',
        'Upgrade <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> plugin to v2.1.1'
      ]
    }, {
      version: '2.1.3',
      time: '2018.11.26',
      changes: [
        'Fixed slot content is not inherit to children components',
        'Added city picker mode, use province for title and citys for list view, config <code>city-picker</code> option to use',
        'Fixed provincial county and provincial-level city show incorrect issue',
        'Fixed when region item initialized and changed province item, the "area", "town" items is not cleared',
        'Fixed when some item selected and click the "x" icon to clear selected items, click dropdown caller button will not show dropdown up'
      ]
    }, {
      version: '2.0.0',
      time: '2018.11.17',
      changes: [
        'rebuild plugin',
        'Fixed area level no data when selected prefecture-level city',
        'Added virtual level data when selected municipalities directly under the central government or prefecture-level city',
        'Added <code>disabled</code> option, allow to disabled the select element in regular select mode',
        'Added selector with column group mode, config <code>column</code> option to use',
        'Added <code>x</code> icon(clear selected items) when some item be selected in selector mode'
      ]
    }, {
      version: '1.8.1',
      time: '2018.10.06',
      changes: [
        'Added default region caller as a button in UI selector mode',
        'Fixed switch between province and municipalities directly under the central government, city display is incorrect',
        'Modify auto close selector when last region level select complete in UI selector mode',
        'The drop down container layer change to plugin <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>',
        'Adjust icon font name and class name, avoid conflicts with ICON font content in the user environment',
        'Perfect i18n content'
      ]
    }, {
      version: '1.7',
      time: '2018.06.21',
      changes: [
        'Fixed area/county and town/street not clear when province change'
      ]
    }, {
      version: '1.6',
      time: '2018.06.19',
      changes: [
        'Added selected region text output only mode, set "text" to true',
        'Fixed form element mode modify superior level, the lower level region unclear issues',
        'Fixed some typography and style issues',
        'Fixed some town/street data missing, the error info show in console issues'
      ]
    }, {
      version: '1.5',
      time: '2018.06.09',
      changes: [
        'Fixed screen scroll to top when open selector'
      ]
    }, {
      version: '1.3-1.4',
      time: '2018.05-2018.06',
      changes: [
        'Added dropdown selector mode, just set <code>ui</code> option to <code>true</code>'
      ]
    }, {
      version: '1.0-1.2',
      time: '2018.04-2018.05',
      changes: [
        'Develop and publish <code>v-region</code> plugin for <strong>Vue2</strong>'
      ]
    }
  ]
}
